import script from "./colorcardDailyList.vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardDailyList.vue?vue&type=script&setup=true&lang=js"

import "./colorcardDailyList.vue?vue&type=style&index=0&id=1cb45e38&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb45e38"]])

export default __exports__